import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as studentRecordService from '../services/studentRecordService';

export const useStudentRecords = (filters = {}) => {
  return useQuery({
    queryKey: ['student-records', filters],
    queryFn: () => studentRecordService.listRecords(filters).then(r => r.data),
    enabled: true,
  });
};

export const useStudentRecord = (recordId) => {
  return useQuery({
    queryKey: ['student-record', recordId],
    queryFn: () => studentRecordService.getRecord(recordId).then(r => r.data),
    enabled: !!recordId,
  });
};

export const useCreateRecord = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: studentRecordService.createRecord,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['student-records'] });
    },
  });
};

export const useAddFollowUp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ recordId, data }) => studentRecordService.addFollowUp(recordId, data),
    onSuccess: (_, { recordId }) => {
      queryClient.invalidateQueries({ queryKey: ['student-record', recordId] });
      queryClient.invalidateQueries({ queryKey: ['student-records'] });
    },
  });
};

export const useDeleteRecord = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: studentRecordService.deleteRecord,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['student-records'] });
    },
  });
};
